export default __webpack_public_path__ + "static/media/videoColor.6f17e039.png";